import Vue from 'vue'
import Component from 'vue-class-component'

import { setResponse } from '@/services/session.service'
import EmailComponent from '@/components/email.vue'
import WebpageComponent from '@/components/webpage.vue'

declare const config: any

@Component({

    components: {
        EmailComponent,
        WebpageComponent
    }
})
export default class TrainingComponent extends Vue {
    step = 1
    webmailList = []
    emailsList = [{
        id: ''
    }]

    webpagesList = [{
        id: '',
        url: ''
    }]

    steps = [{
        type: '',
        samples: []
    }]

    answer = {
        answer: ''
    }

    servUrl = ''
    sessionId = ''
    response = ''
    webmailResponseSend = false
    solution = ''
    emailSelected = { id: 'string' }
    emailId = ''
    webpageSelected = { id: 'string' }
    emailIndex = 0
    webpageIndex = 0
    mailSelected = false
    pageSelected = false
    slideSelected = false
    slide = 'a'
    seeGoodAnswer = false
    displayBubbleBlock = false
    classAnimation = ''
    displayVerify = false
    goodAnswer = false // a tester
    goToNextStep = false // a tester
    innerWidth = 0
    mobileMode = false
    displayExplanation = false
    displayExplanationSlide = false
    disabledAction = false
    mail = { id: 'string' }
    emailLegit = { id: 'string' }
    emailPhishing = { id: 'string' }
    webpageLegit = { id: 'string' }
    webpagePhishing = { id: 'string' }
    param = {
        brand: 'string',
        domain: 'string',
        url: 'string'
    }

    brand = {
        name: 'string',
        domains: 'array',
        urls: 'array',
    }

    domainsList = ''
    urlsList = {}

    created() {
        window.addEventListener('resize', this.onResize)
        this.servUrl = config.BASE_URL

        if (sessionStorage.getItem('currentStep')) {
            this.initCurrentStep()
        } else {
            sessionStorage.setItem('currentStep', '{"step": 1, "response": {"answered": false}}')
        }
        if (sessionStorage.getItem('brand')) {
            this.brand = JSON.parse(sessionStorage.getItem('brand') || '{}')
        }
        const url = new URL(this.brand.urls[0])
        this.param = {
            brand: this.brand.name,
            domain: this.brand.domains[0],
            url: url.hostname
        }
        this.domainsList = this.brand.domains
        this.urlsList = this.brand.urls

        this.setSteps()
        this.onResize()
        this.generateDate(0)
    }

    onResize() {
        this.innerWidth = window.innerWidth
        if (this.innerWidth <= 980) {
            this.mobileMode = true
        } else {
            this.mobileMode = false
        }
    }

    initCurrentStep() {
        const currentStep = JSON.parse(sessionStorage.getItem('currentStep') || '{}')
        this.step = currentStep.step

        if (currentStep.response.answered) {
            this.goodAnswer = currentStep.response.goodAnswer
            this.webmailResponseSend = currentStep.response.webmailResponseSend
            this.goToNextStep = currentStep.response.goToNextStep
            this.emailId = currentStep.response.emailId
            this.solution = currentStep.response.solution
            this.displayExplanationSlide = currentStep.response.displayExplanationSlide
            this.emailSelected = currentStep.response.emailSelected
            this.webpageSelected = currentStep.response.webpageSelected
            this.mail = currentStep.response.mail
            this.displayBubbleBlock = currentStep.response.displayBubbleBlock
        }
    }

    setSteps() {
        this.steps = JSON.parse(sessionStorage.getItem('steps') || '{}')
        for (let i = 0; i < this.steps.length; i += 1) {
            if (this.steps[i].type === 'webmail') {
                this.webmailList = this.steps[i].samples
            }
            if (this.steps[i].type === 'emails') {
                this.emailsList = this.steps[i].samples
            }
            if (this.steps[i].type === 'webpages') {
                this.webpagesList = this.steps[i].samples
            }
        }
    }

    getImage(type: string, elmnt: any) {
        const screenshotArray = elmnt.screenshots
        let size

        if (this.mobileMode) {
            size = screenshotArray.find((element: any) => element.split('x')[0] < 960)
        } else {
            size = screenshotArray.find((element: any) => element.split('x')[0] > 960)
        }
        return `${this.servUrl}/${type}/${elmnt.id}/screenshots/${size}.png`
    }

    next(step: number) {
        this.step = step

        this.displayVerify = false
        this.displayBubbleBlock = false
        this.goToNextStep = false
        this.displayExplanation = false
        this.displayExplanationSlide = false
        this.webmailResponseSend = false
        this.seeGoodAnswer = false

        sessionStorage.setItem('currentStep', JSON.stringify({ step: this.step, response: { answered: false } }))
    }

    getExplanation() {
        this.displayExplanation = true
        this.displayBubbleBlock = false
        this.goToNextStep = false
    }

    checkResponse(mail: any) {
        if (!this.disabledAction) {
            this.mail = mail
            sessionStorage.setItem('currentStep', JSON.stringify({
                step: this.step,
                response: {
                    answered: true, goodAnswer: this.goodAnswer, goToNextStep: this.goToNextStep, webmailResponseSend: this.webmailResponseSend, emailId: this.emailId, solution: this.solution, displayExplanationSlide: this.displayExplanationSlide, mail: this.mail, emailSelected: this.emailSelected, webpageSelected: this.webpageSelected, displayBubbleBlock: this.displayBubbleBlock
                }
            }))
            this.emailId = mail.id

            this.verifyStep()
        }
    }

    addZero(i: any) {
        let index = i
        if (i < 10) {
            index = `0${i}`
        }
        return index
    }

    generateDate(index: number) {
        const dDate = new Date()
        dDate.setHours(dDate.getHours() - index)
        dDate.setMinutes(dDate.getMinutes() - index * 7)

        return `${this.addZero(dDate.getHours())}:${this.addZero(dDate.getMinutes())}`
    }

    changeSlide(slide: string) {
        let index
        this.slide = slide
        if (this.slide === 'b') {
            index = 1
            this.classAnimation = 'next-slide'
        } else {
            index = 0
            this.classAnimation = 'prev-slide'
        }
        this.emailIndex = index
        this.webpageIndex = index
        this.mailSelected = false
        this.slideSelected = false

        this.emailSelected = this.emailsList[index]
        this.webpageSelected = this.webpagesList[index]
    }

    verifyStep() {
        if (!this.webmailResponseSend) {
            this.setResponse()
        } else {
            const res = { solution: this.solution }
            this.setResponseSuccess(res)
        }
        this.disabledAction = true
    }

    setResponse(type?: string) {
        this.slide = 'a'
        this.classAnimation = ''

        if (type === 'email') {
            this.emailId = this.emailsList[this.emailIndex].id
            this.emailSelected = this.emailsList[this.emailIndex]
        } else if (type === 'webpage') {
            this.emailId = this.webpagesList[this.webpageIndex].id
            this.webpageSelected = this.webpagesList[this.webpageIndex]
        }

        this.answer = {
            answer: this.emailId
        }
        this.sessionId = sessionStorage.getItem('id') || ''

        setResponse(this.sessionId, this.step - 1, this.emailId)
            .then((res) => {
                this.setResponseSuccess(res.data)
            })
            .catch((err) => {
                if (err.response.status === 403) {
                    this.$router.push({
                        name: 'Error',
                        query: { error: 'tokenExpired' }
                    })
                } else {
                    this.$router.push({ name: 'Error' })
                }
            })
    }

    displayExplanationForMobileSlide() {
        this.displayExplanationSlide = true
        this.displayBubbleBlock = false
        this.displayExplanation = true

        if (this.step === 2) {
            for (let i = 0; i < this.emailsList.length; i += 1) {
                if (this.solution === this.emailsList[i].id) {
                    this.emailPhishing = this.emailsList[i]
                } else {
                    this.emailLegit = this.emailsList[i]
                }
            }
        } else {
            for (let i = 0; i < this.webpagesList.length; i += 1) {
                if (this.solution === this.webpagesList[i].id) {
                    this.webpagePhishing = this.webpagesList[i]
                } else {
                    this.webpageLegit = this.webpagesList[i]
                }
            }
        }
    }

    setResponseSuccess(res: any) {
        if (this.emailId === res.solution) {
            this.goodAnswer = true
            this.goToNextStep = true
        } else {
            this.goodAnswer = false
            this.goToNextStep = false
        }
        this.displayBubbleBlock = true
        if ((this.step === 2 || this.step === 3) && !this.mobileMode) {
            this.displayExplanationSlide = true
        }

        this.solution = res.solution
        this.displayVerify = false

        let array
        if (sessionStorage.getItem('result')) {
            array = JSON.parse(sessionStorage.getItem('result') || '{}')
        } else {
            array = []
        }
        if (!this.webmailResponseSend) {
            array.push({ id: this.step, goodAnswer: this.goodAnswer, response: res.solution })
            sessionStorage.setItem('result', JSON.stringify(array))
        }

        sessionStorage.setItem('currentStep', JSON.stringify({
            step: this.step,
            response: {
                answered: true, goodAnswer: this.goodAnswer, goToNextStep: this.goToNextStep, webmailResponseSend: this.webmailResponseSend, emailId: this.emailId, solution: this.solution, displayExplanationSlide: this.displayExplanationSlide, emailSelected: this.emailSelected, webpageSelected: this.webpageSelected, displayBubbleBlock: this.displayBubbleBlock
            }
        }))

        this.emailIndex = 0
        this.webpageIndex = 0
        this.webmailResponseSend = true
    }

    tryAgain() {
        this.displayVerify = false
        this.emailId = ''
        this.disabledAction = false
        this.displayBubbleBlock = false
    }

    getGoodAnswer(type: string) {
        this.goodAnswer = true
        this.displayBubbleBlock = false
        this.seeGoodAnswer = true

        if (type === 'email') {
            for (let i = 0; i < this.emailsList.length; i += 1) {
                if (this.solution === this.emailsList[i].id) {
                    this.emailSelected = this.emailsList[i]
                }
            }
        } else {
            for (let i = 0; i < this.webpagesList.length; i += 1) {
                if (this.solution === this.webpagesList[i].id) {
                    this.webpageSelected = this.webpagesList[i]
                }
            }
        }
    }

    goToResult() {
        this.$router.push({ name: 'Result' })
        sessionStorage.setItem('end', JSON.stringify(new Date()))
    }
}
